import { fileData } from "@/data";

export const uploadMotionArtworkFileHandler = async (importerData) => {
    const { formMethods, motionArtwork, uploadFile } = importerData;

    await uploadFile(motionArtwork?.file, formMethods, fileData.names.motionArtwork, null, {
        assetType: motionArtwork?.type?.value,
        importerData: {
            ...importerData,
            uploadingMotionArtworkFile: true,
        },
    });
};

export const getMotionArtworksHandler = (upc, files, setMotionArtworks) => {
    let releaseMotionArtworks = [];

    const releaseMotionArtworksFilteredArray = files?.filter(
        (file) =>
            file?.name?.includes(upc) &&
            fileData.extensions.motionArtwork.some((item) => item !== "xls" && file.name.toLowerCase().includes(item)),
    );

    if (releaseMotionArtworksFilteredArray?.length > 0)
        releaseMotionArtworks = releaseMotionArtworks.concat(releaseMotionArtworksFilteredArray);

    if (releaseMotionArtworks?.length > 0) {
        releaseMotionArtworks.forEach((motionArtwork) => {
            const typeIndex = motionArtwork?.name?.indexOf("_");

            const motionArtworkType =
                typeIndex > 0
                    ? motionArtwork?.name
                          ?.split(".")
                          .slice(0, -1)
                          .join(".")
                          .substring(typeIndex + 1)
                    : undefined;

            setMotionArtworks((prev) => {
                const newMotionArtwork = {
                    file: motionArtwork,
                    ...(motionArtworkType && { type: motionArtworkType }),
                    upc,
                };

                return {
                    ...prev,
                    [upc]:
                        prev?.[upc]?.length > 0
                            ? prev?.[upc].concat([newMotionArtwork])
                            : [].concat([newMotionArtwork]),
                };
            });
        });
    }
};
